import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { LabelDimensions, PrinterListItem, PrinterStatus } from '../models';

export const printersActions = createActionGroup({
    source: 'Printers',
    events: {
        // `withStatus` asks for the live status fan-out; `background` skips the full-page loader.
        'Get Printers': props<{ withStatus: boolean; background?: boolean }>(),
        'Get Printers Success': props<{ payload: PrinterListItem[]; withStatus: boolean }>(),
        'Get Printers Error': props<{ code: number }>(),
        // Live status per row — fanned out (max 3 concurrent) after the list loads
        'Printer Status Loaded': props<{ id: string; status: PrinterStatus }>(),
        'Printer Status Error': props<{ id: string }>(),
        // Per-label-type print geometry — a system constant, fetched once for the station form.
        'Get Label Dimensions': emptyProps(),
        'Get Label Dimensions Success': props<{ payload: LabelDimensions[] }>(),
        'Get Label Dimensions Error': props<{ code: number }>(),
        // Sync from the single-printer store (dispatched by PrinterPrintersBridge)
        'Printer Removed': props<{ id: string }>(),
        Clear: emptyProps(),
    },
});
